import { DatePicker } from 'antd'
import styled from 'styled-components'

const { RangePicker } = DatePicker

const RangePickerStyled = styled(RangePicker)`
  margin: 0.5rem 0.5rem 0 0;
`
export default RangePickerStyled
